import React from "react"
import { Box } from "@mui/material"
import { AppFormSection } from "@components"
import { SwitchCSV } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import ReportFormDrawerDateSection from "./DateSection"
import ReportFormDrawerCsvSection from "./CsvSection"


export default function ReportFormDrawerSearchConfigSection() {

	return <AppFormSection
		icon="magnifying-glass"
		title="Search Configuration"
		action={<Box data-tour-id="tour-csv-switch"><SwitchCSV/></Box>}
	>
		<SearchConfigurationSubSection/>
	</AppFormSection>
}

function SearchConfigurationSubSection() {

	return useCsv.value ? <ReportFormDrawerCsvSection/> : <ReportFormDrawerDateSection/>
}
